import React, { useEffect, useReducer, useContext } from 'react'

import { Box, Autocomplete, TextField, List, CircularProgress, ListItem, Tooltip } from '@mui/material'
import timeoutList from '../../Utils/TimeoutList'
import ColorButton from '../../Buttons/ColorButton'
import { NumericFormatInput } from '../../Utils/MaskedInput'
import { lockedReducer } from '../../Utils/reducers'
import DefaultModal from '../../Utils/DefaultModal'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import { externalComponent } from '../../AppRoutes'
import validateData from './validateData'

import Alert from '@mui/material/Alert';



const ServiceSelectionMain = ({ state, setState }) => {
    return (
        <>
            <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Autocomplete
                    multiple
                    sx={{ flex: 1 }}
                    id={'autocompletebox-service'}
                    value={state.services}
                    options={state.loaded_services.filter(each => !state.services.map(e => e.id).includes(each.id))}
                    onChange={(e, selectedServices) => { setState({ services: selectedServices }) }}
                    autoHighlight
                    handleHomeEndKeys
                    clearText='Limpar'
                    noOptionsText='Digite para pesquisar Serviços'
                    loading={state.smallLoading}
                    ChipProps={{ size: 'small' }}
                    filterSelectedOptions
                    onOpen={() => state.loaded_services.length === 0 && timeoutList('', `order/serviceorder/services/`, 'loaded_services', 'name', setState, true)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            id={'autocompleteinput'}
                            type="text"
                            sx={{ backgroundColor: 'white' }}
                            label="Serviços"
                            size="small"
                            fullWidth={true}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    }
                />
            </Box>
            {state.services.length > 0 &&
                <>
                    <List className='product-service-list'>
                        {state.services.map((service, index) => (
                            <Box className='product-service-list-wrapper'>
                                <ListItem className='nopadding' key={`service-listitem${service.id}`} title={service.label}>
                                    <Box className='simple-label'>
                                        <Box>{service.label}</Box>
                                        <Box className='single-line'></Box>
                                    </Box>
                                    <TextField
                                        size='small'
                                        label='Valor.'
                                        className='simple-value'
                                        value={service.value}
                                        inputProps={{
                                            maxLength: 13
                                        }}
                                        InputProps={{
                                            inputComponent: NumericFormatInput
                                        }}
                                        onChange={(e) => { service.value = e.target.value; setState({ services: [...state.services] }) }} />
                                </ListItem>

                                <TextField
                                    multiline
                                    maxRows={4}
                                    label='Descrição'
                                    value={service.procedure}
                                    size='small'
                                    onChange={e => { service.procedure = e.target.value; setState({ services: [...state.services] }) }}
                                />
                            </Box>
                        ))}
                        <Box sx={{ marginTop: '2rem', display: 'flex', justifyContent: 'end', gap: '1rem' }}>
                            <TextField
                                label='Valor total'
                                value={state.services.reduce((total, service) => {
                                    const numericValue = parseFloat(service.value) || 0;
                                    return total + numericValue
                                }, 0)}
                                size='small'
                                inputProps={{
                                    maxLength: 13
                                }}
                                InputProps={{
                                    inputComponent: NumericFormatInput
                                }}
                                disabled={true}
                            />
                        </Box>
                    </List>
                </>}

            {!state.services.length > 0 && <Alert sx={{ width: '100%', marginTop: '1rem' }} severity="warning">Selecione um ou mais serviços antes de continuar.</Alert>}
        </>
    )
}

const submit_services = async (setLoader, recallData, intstate, reloadData, reloadProposalRow) => {
    setLoader(true)
    const res = await api.post(`order/serviceorder/${recallData.id}/update_services/`, intstate)
    if (res.status === 200) {
        reloadProposalRow()
        reloadData()
        toast.success('Serviços salvo com sucesso!')
    }
    setLoader(false)
}

const initialize = async (setIntstate, recallData, setLoader) => {
    setLoader(true)
    const res = await api.get(`order/serviceorder/${recallData?.id}/services_list/`)
    if (res.status === 200) {
        setIntstate({ loaded: true, services: res.data })
    } else {
        toast.error('Dados de serviços não encontrados.')
    }
    setLoader(false)

}

const ServiceSelection = ({ state, setState, handleClose = () => { }, recallData, submit = () => { }, reloadProposalRow, reloadData }) => {

    const { setLoader } = useContext(externalComponent)

    const [intstate, setIntstate] = useReducer(lockedReducer, {
        loaded_services: [],
        loaded_products: [],
        services: [],
        total_value: 0,
        loaded: false,
        step: 1
    })

    useEffect(() => {
        if (recallData)
            initialize(setIntstate, recallData, setLoader)
    }, [recallData?.id, setLoader])

    const validData = validateData(intstate)


    return (
        <>
            {!recallData ?
                <ServiceSelectionMain state={state} setState={setState} />
                :
                <>
                    {
                        intstate.loaded &&
                        <DefaultModal
                            handleClose={handleClose}
                            title='Alterar produtos'
                            dialogProps={{ maxWidth: 'xl', fullWidth: true }}
                            content={
                                <ServiceSelectionMain state={intstate} setState={setIntstate} hideSelection={true} />
                            }
                            action={
                                <>
                                    <Tooltip title={validData}>
                                        <span>
                                            <ColorButton
                                                onClick={() => { submit_services(setLoader, recallData, intstate, reloadData, reloadProposalRow); submit(intstate.services) }}
                                                disabled={validData}>
                                                Salvar
                                            </ColorButton>
                                        </span>
                                    </Tooltip>
                                </>
                            }

                        />
                    }
                </>
            }
        </>
    )
}

export default ServiceSelection